export default {
  SET_USER_SELECTED_COMPANY: 'SET_USER_SELECTED_COMPANY',
  SET_USER_COMPANY_LIST: 'SET_USER_COMPANY_LIST',
  CLEAR_COMPANY_STORE: 'CLEAR_COMPANY_STORE',
  SET_COMPANY_USERS: 'SET_COMPANY_USERS',
  SET_USER_SELECTED_API_DOCS_COMPANY: 'SET_USER_SELECTED_API_DOCS_COMPANY',
};
